/**
 * Validates if the user is at least 15 years old based on date of birth
 */
export const validateAge = (dateOfBirth: string): boolean => {
  if (!dateOfBirth) return false;

  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  // Check if date is in the future
  if (birthDate > today) return false;

  // Calculate age
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // Adjust age if birthday hasn't occurred this year yet
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 15;
};

/**
 * Gets the maximum allowed date for date of birth (today - 15 years)
 */
export const getMaxBirthDate = (): string => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 15);
  return today.toISOString().split("T")[0];
};
